import { render, staticRenderFns } from "./ModalBroadcastMessageRoster.vue?vue&type=template&id=5404d361&scoped=true"
import script from "./ModalBroadcastMessageRoster.vue?vue&type=script&lang=js"
export * from "./ModalBroadcastMessageRoster.vue?vue&type=script&lang=js"
import style0 from "./ModalBroadcastMessageRoster.vue?vue&type=style&index=0&id=5404d361&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5404d361",
  null
  
)

export default component.exports